import { SignupLanguage } from '../types/signupLanguage'

const signupLanguages = new Set<string>(['da', 'en', 'fr', 'de', 'nl'] satisfies SignupLanguage[])

export const isSignupLanguage = (value?: string): value is SignupLanguage => !!value && signupLanguages.has(value)
